import React from "react";

function Micro() {
  return (
    <svg
      width="35"
      height="30"
      viewBox="0 0 35 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.4531 26.3248H30.368V21.3139C30.368 19.1998 28.3609 17.4795 25.8945 17.4795C23.4281 17.4795 21.421 19.1998 21.421 21.3139V26.3248H0.546845C0.240629 26.3248 0 26.5357 0 26.7935V29.5311C0 29.7889 0.240629 29.9998 0.546845 29.9998H34.4531C34.7538 29.9998 34.9999 29.7889 34.9999 29.5311V26.7935C35 26.5357 34.7539 26.3248 34.4531 26.3248ZM25.8954 22.9024C24.8722 22.9024 24.0427 22.1914 24.0427 21.3144C24.0427 20.4374 24.8722 19.7264 25.8954 19.7264C26.9187 19.7264 27.7481 20.4374 27.7481 21.3144C27.7481 22.1914 26.9186 22.9024 25.8954 22.9024Z"
        fill="#EDD444"
      />
      <path
        d="M7.75485 19.1671C7.44864 19.1671 7.20801 19.378 7.20801 19.6358V22.3733C7.20801 22.6311 7.44864 22.842 7.75485 22.842H20.3274V21.3138C20.3274 20.5412 20.5476 19.8132 20.9295 19.167H7.75485V19.1671Z"
        fill="#EDD444"
      />
      <path
        d="M20.9346 3.72608C21.1206 3.72608 21.3021 3.74108 21.4813 3.76262V2.10002C21.4813 1.84221 21.2352 1.63129 20.9344 1.63129H19.9118V0.468725C19.9118 0.210923 19.6712 0 19.3649 0H15.6298C15.329 0 15.0829 0.210923 15.0829 0.468725V1.63123H14.0603C13.7595 1.63123 13.5134 1.84215 13.5134 2.09995V14.5874C13.5134 14.8452 13.7595 15.0562 14.0603 15.0562H14.6837V16.3921C14.6837 16.6546 14.9298 16.8608 15.2305 16.8608H19.7641C20.0649 16.8608 20.311 16.6546 20.311 16.3921V15.0562H20.9344C21.2351 15.0562 21.4812 14.8452 21.4812 14.5874V10.4107C21.302 10.4323 21.1205 10.4473 20.9345 10.4473C18.7726 10.4473 17.014 8.93964 17.014 7.08665C17.014 5.23367 18.7728 3.72608 20.9346 3.72608Z"
        fill="#EDD444"
      />
      <path
        d="M24.803 6.56543C24.8341 6.73576 24.8551 6.90902 24.8551 7.0867C24.8551 8.29976 24.099 9.36147 22.9719 9.95246C25.1388 11.3067 26.436 13.4443 26.436 15.7875C26.436 16.0461 26.4138 16.3051 26.3808 16.5634C27.9895 16.6836 29.4004 17.3929 30.3258 18.4372C30.5808 17.5708 30.7234 16.6852 30.7234 15.7875C30.7234 12.028 28.4477 8.5555 24.803 6.56543Z"
        fill="#EDD444"
      />
      <path
        d="M20.9345 4.66357C19.3756 4.66357 18.1077 5.7505 18.1077 7.08676C18.1077 8.42296 19.3755 9.50995 20.9345 9.50995C22.4935 9.50995 23.7613 8.42302 23.7613 7.08676C23.7613 5.75056 22.4934 4.66357 20.9345 4.66357ZM21.4813 7.55549H20.3876V6.61797H21.4813V7.55549Z"
        fill="#EDD444"
      />
    </svg>
  );
}

export default Micro;
